import JoinWaitlistButton from "./JoinWaitlistButton";
import DraggableIcons from "./DraggableIcons";
import Cards from "./Cards";
import FullWidthCard from "./FullWidthCard";
import IrregularShapesSection from "./IrregularShapesSection";
import Footer from "./Footer";
import Carousel from "./Carousel";
import HorizontalCard from "./HorizontalCard";
import Globe from "../components/Globe";

function Home() {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <DraggableIcons />

      {/* Social Proof Strip */}
      <Carousel />

      {/* Features Grid */}
      <Cards />

      {/* Process Section */}
      <IrregularShapesSection />

      {/* Global Reach / Globe Section */}
      <section className="w-full py-24 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded-full text-sm font-bold mb-6 border border-blue-100">
              <span>🌎</span> Global Reach
            </div>
            <h2 className="text-3xl md:text-5xl font-black text-black mb-6 tracking-tight">
              Explore the World with Braccet
            </h2>
            <p className="text-gray-500 text-lg md:text-xl font-medium max-w-2xl mx-auto">
              Discover a new way of creative collaboration, connecting talent across borders.
            </p>
          </div>

          <div className="relative h-[400px] md:h-[600px] bg-blue-50/30 rounded-[3rem] border border-blue-50 overflow-hidden">
             <div className="absolute inset-0 flex items-center justify-center">
               <Globe />
             </div>
          </div>
        </div>
      </section>

      {/* Call Card */}
      <HorizontalCard />

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default Home;
